(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.initCartAnimations();
      this.hideSearchCloseButton();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      let observer = new IntersectionObserver((entries, observerInstance) => {
        this.headerBounds = entries[0].intersectionRect;
        observerInstance.disconnect();
      });

      observer.observe(this.header);
    }

    hideSearchCloseButton() {
      const closeButtons = document.querySelectorAll('.header__icon-close, .svg-wrapper.header__icon-close');
      closeButtons.forEach(btn => {
        btn.style.display = 'none';
      });

      const searchDetails = document.querySelectorAll('.header__search details, modal-opener');
      searchDetails.forEach(detail => {
        detail.addEventListener('toggle', function() {
          const closeBtn = this.querySelector('.header__icon-close') ||
                           (this.nextElementSibling && this.nextElementSibling.querySelector('.header__icon-close'));

          if (closeBtn) {
            if (this.hasAttribute('open') || this.open) {
              closeBtn.style.display = 'flex';
            } else {
              closeBtn.style.display = 'none';
            }
          }
        });
      });

      closeButtons.forEach(btn => {
        btn.addEventListener('click', function() {
          setTimeout(() => {
            this.style.display = 'none';
          }, 100);
        });
      });
    }

    initCartAnimations() {
      const cartBubble = document.querySelector('.cart-count-bubble');
      const cartIcon = document.querySelector('.header__icon--cart');

      if (!cartIcon) return;

      if (cartBubble) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
              cartBubble.classList.remove('cart-updated');
              void cartBubble.offsetWidth;
              cartBubble.classList.add('cart-updated');

              setTimeout(() => {
                cartBubble.classList.remove('cart-updated');
              }, 600);
            }
          });
        });

        observer.observe(cartBubble, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      document.addEventListener('cart:updated', () => {
        const bubble = document.querySelector('.cart-count-bubble');
        if (!bubble) return;
        bubble.classList.remove('cart-updated');
        void bubble.offsetWidth;
        bubble.classList.add('cart-updated');

        setTimeout(() => {
          bubble.classList.remove('cart-updated');
        }, 600);
      });
    }

    onScroll() {
      if (!this.headerBounds || !this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header && this.header.querySelectorAll('header-menu');
      if (!this.disclosures) return;
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header && this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
